import React, { useState, useEffect } from 'react'

// Material UI breakpoints (in pixels)
const breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
}

export const useBreakpoints = () => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0
  })

  useEffect(() => {
    if (typeof window === 'undefined') return

    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const width = windowSize.width

  return {
    width,
    height: windowSize.height,

    xsUp: width >= breakpoints.xs,
    smUp: width >= breakpoints.sm,
    mdUp: width >= breakpoints.md,
    lgUp: width >= breakpoints.lg,
    xlUp: width >= breakpoints.xl,

    currentBreakpoint: (() => {
      if (width >= breakpoints.xl) return 'xl'
      if (width >= breakpoints.lg) return 'lg'
      if (width >= breakpoints.md) return 'md'
      if (width >= breakpoints.sm) return 'sm'
      return 'xs'
    })(),

    isXs: width < breakpoints.sm,
    isSm: width >= breakpoints.sm && width < breakpoints.md,
    isMd: width >= breakpoints.md && width < breakpoints.lg,
    isLg: width >= breakpoints.lg && width < breakpoints.xl,
    isXl: width >= breakpoints.xl
  }
}
